export default "__VITE_ASSET__C4$b5zKf__"